import { Component, Injector, OnInit } from '@angular/core';
import { ComparablesTabs, ModulesEnum } from 'src/app/navigation/enum';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { WorkplaceAreaHostBase } from '../../../components/common/workplace-area-host-base/workplace-area-host-base';

/**
 * Handles comparables host component
 */
@Component({
  selector: 'comparables-host',
  templateUrl: './comparables-host.component.html',
  styleUrls: ['./comparables-host.component.scss']
})
export class ComparablesHostComponent extends WorkplaceAreaHostBase implements OnInit {
  /**
   * Sets the infobar visibility
   * @param mode Show (true) or hide
   * @param areaChanged Area changed?
   * @param enableSettings Enable settings
   * @param params Parameters
   */
  public setInfoBarVisibility(mode: boolean, areaChanged: boolean, enableSettings: boolean = undefined, params: any = undefined) {
    this.infoBarVisibility = mode;

    if (mode) {
      // PIX Integration buttons
      this.eventBus.broadcastEvent('comparablesVisibility', true);
      this.eventBus.broadcastEvent('comparablesVisibilityCheckProperty');
    }

    this.eventBus.broadcastEvent('comparables-infobar-changed', {
      show: mode, areaChanged, enableSettings, params
    });
  }

  /**
   * Constructor
   * @param navigationService
   */
  constructor(private navigationService: NavigationService,
    injector: Injector) {
    super(injector);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.navigationService.setActiveModule(ModulesEnum.Comparables);
    this.navigationService.setActiveComparablesTab(ComparablesTabs.Properties);

    this.onEvents.push(this.eventBus.subscribeEvent('searchBarVisibility', (visibility, tab) => {
      this.searchTabVisible = visibility;
      this.searchTab = tab;
      this.setSearchModeVisibility(visibility);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('buttonImport', () => {
      this.doImport();
    }));
  }

  /**
   * Gets the default pane widths
   * @returns the default pane widths
   */
  public getPaneWidths(): Map<string, number> {
    return new Map<string, number>([
      ['#comparables-infobar', 250],
      ['#comparables-searchbar', 250]
    ]);
  }

  /**
   * Returns infobar width (as defined in getPaneWidths)
   * @returns The infobar width
   */
  public get infobarWidth(): number {
    return this.infoBarVisibility ? this.paneWidths.get('#comparables-infobar') : 0;
  }

  /**
   * Starts import for current area
   */
  public doImport(): void {
    if (!this.selectedImportArea) {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'noImportInThisSection');
    } else {
      const importParameter = { importArea: this.selectedImportArea };
      this.eventBus.broadcastEvent("startAppImport", importParameter);
    }
  }
}
